import React from "react";

export const getUnitType = (indicator: any): string => {
    let type = (indicator?.unitTypes || [])[0] || indicator?.unitType
    return type?.name || ''
}

export default getUnitType;